const headCarousel = [
  {
    title: "Vincenzo",
    category: "Thriler",
    img:
      "https://wallpaperaccess.com/full/6227689.jpg"
  },
    {
      title: "Descendants Of The Sun",
      category: "Drama",
      img:
      "https://wallpapercave.com/wp/wp2167255.jpg"
    },
    {
      title: "Parasite",
      category: "Movies",
      img:
        "https://media.newyorker.com/photos/5da4a5c756dcd400082a63ba/master/pass/Brody-Parasite.jpg"
    },

  ];
  export { headCarousel };
  